module.exports = __webpack_public_path__ + "static/media/cloud.86cc0c72.svg";